// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"Result_resetBtn__1HSkv"};